import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@styles';

// Material-UI
import Tooltip from '@material-ui/core/Tooltip';

const styles = () => ({
  tooltip: {
    fontFamily: 'Bryant Pro Regular',
    fontSize: Theme.typography.smallText,
    color: Theme.colors.greyDark,
    backgroundColor: Theme.colors.white,
    boxShadow: Theme.shadows.depth2,
    borderRadius: '6px',
    margin: '8px',
    padding: '8px',
    lineHeight: '1.3',
    letterSpacing: '0.0175em'
  },
  popper: {
    willChange: 'auto !important'
  }
});

const MuiTooltip = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <Tooltip
      enterDelay={500}
      leaveDelay={200}
      PopperProps={{
        modifiers: { computeStyle: { gpuAcceleration: false } }
      }}
      {...restProps}
    >
      <span style={{ display: 'flex' }}>
        {children}
      </span>
    </Tooltip>
  );
};

MuiTooltip.propTypes = {
  // Tooltip reference element.
  children: PropTypes.node.isRequired,
};

export const StyledTooltipLight = withStyles(styles)(MuiTooltip);